export default __webpack_public_path__ + "static/media/illuminate-form.63b54bf6.jpg";